export const Date_format = {
    date_format: "mm-dd-yyyy",
    date_format_search: "MM-DD-YYYY"
};

export function formatDate(date, noTimeZone = false) {
    if (date) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedDate = noTimeZone ? new Date(date  + "T00:00:00").toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        }) : new Date(date).toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            timeZone: userTimeZone
        });

        const [month, day, year] = formattedDate.replace(/,/g, "").split(" ");
        return `${day}-${month}-${year}`;
    } else {
        return "";
    }
}


export function DateFormatter(date, dateOnly = false) {
    if (date) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const formatOptions = {
            day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
                hour12: false,
                timeZone: userTimeZone
        };

        // Check for the DATE_FORMAT and modify the formatOptions accordingly
        if (Date_format.date_format === "mm-dd-yyyy") {
            formatOptions.month = "short";
            formatOptions.day = "2-digit";
            formatOptions.year = "numeric";
        } else if (Date_format.date_format === "dd-mm-yyyy") {
            formatOptions.day = "2-digit";
            formatOptions.month = "short";
            formatOptions.year = "numeric";
        } else if (Date_format.date_format === "yyyy-mm-dd") {
            formatOptions.year = "numeric";
            formatOptions.month = "short";
            formatOptions.day = "2-digit";
        }
        // Add more conditions as needed for date formats

        // Format the date using the modified formatOptions
        const formattedDate = date?.toLocaleString("en-US", formatOptions)?.replace(/\//g, "-");
        const [month, day, year, time] = formattedDate.replace(/,/g, "").split(" ");
        return dateOnly ? `${day}-${month}-${year}` : `${day}-${month}-${year} ${time}`;
    } else {
        return "";
    }

}